import { yupResolver } from '@hookform/resolvers/yup';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Autocomplete, Box, Button, Card, Chip, CircularProgress, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Modal, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import SnackBarUI from '../../comman/SnackBarUI';
import { createQuestionAnswerAction } from '../../redux/toolkit/question-answer/createQuestionAnswer';
import { getAllQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAllQuestionAnswer';
// import { getSubCategoryAction } from '../../redux/toolkit/sub-category/getSubCategory';
import { getCategoryAction } from '../../redux/toolkit/category/getCategory';
import { uplodImageAction } from '../../redux/toolkit/image/uplodImage';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import TagFacesIcon from '@mui/icons-material/TagFaces';
// import { getValue } from '@testing-library/user-event/dist/utils';
import DeleteIcon from '@mui/icons-material/Delete';


import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Body from '../../layout/Body';

let cat_id = ''
let sub_cat_id = ''


// schema
const qns_ans_schema = yup.object({
  question_type: yup.number().required('question type is required'),
  question: yup.string().required('Question is required.'),
  questionId: yup.string().required('Question Id is required.'),
}).required();


export default function CreateQuestionAnswer({ state, setState }) {

  const input = {
    option: null,
    correct: null
  }
  // state
  const { register, setValue, setError, watch, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(qns_ans_schema) });
  const answer_type = watch("answer_type");
  const type = watch('type');

  const question_type = watch("question_type")

  const dispatch = useDispatch()
  const createQns = useSelector(state => state.createQuestionAnswer)
  let { status, message, loading } = createQns
  const getCat = useSelector(state => state.getCategory)
  const { data: getCatData } = getCat

  const getSubCat = useSelector(state => state.getSubCategory)
  const { data: getSubCatData } = getSubCat

  const [snack, setSnack] = useState(false)
  const [ansArr, setAnsArr] = useState([])
  const [answerOption, setAnswerOption] = useState(input)
  const [correct_answer, setCorrect_answer] = useState([])
  const [correctAnswerSelect, setCorrectAnswerSelect] = useState({})
  const [file, setFile] = useState('')
  const [fileLoader, setFileLoader] = useState(false)
  const [answerData, setAnswerData] = useState(false)
  const [timeDuration, setTimeDuration] = useState("")
  const [optionalTrue, setOptionalTrue] = useState(false)
  var singleTrue
  // const [questionType,setQuestionType]=useState('')

  const [deleteBadgeOpen, setDeleteBadgeOpen] = useState(false)



  const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));


  // fn
 
  const handleQns = async (data) => {
    const createQnsDataAction = await dispatch(createQuestionAnswerAction({ dataType: dataType, is_qualifier: isQualifier, ans_options: AnsOption, ...data }))
    if (createQnsDataAction?.payload?.status === 201) {
      await dispatch(getAllQuestionAnswerAction({ is_deleted: false }))
    }
    setDataType('')
    setAnsArr([])
    setSnack(true)
    setState(false)
    reset()
    setFile()
    setAnsOption([])
  }




  const handleClose = function () {
    setAnsArr([])
    setState(false)
  }

  const handleCloseOption =()=>{
    setDeleteBadgeOpen(false)

  }


  const handleAnswerType = (event, value) => {
    if (value === "optional" || value === "MCQ") {
      setAnsArr([])
    }
  }

  const handleAddAnsOpt = () => {
    // setAnswerOption({ ...answerOption, "correct": answerData })

    // setAnswerOption(answerOption=>({...answerOption,"correct": answerData}))

    const foundDuplicate = ansArr.find(element => element === answerOption.option);
    if (foundDuplicate !== undefined) return
    setAnsArr(prev => [...prev, answerOption])

    setAnswerOption({
      option: "",
      correct: false,
    })
  }
  useEffect(() => {
    singleTrue = ansArr.some(item => item.correct === true) ? setOptionalTrue(false) : setOptionalTrue(true)
  }, [ansArr])


 

  // const [age, setAge] = React.useState('');
  const [dataType, setDataType] = useState('')

  const handleChange = (event) => {
    setDataType(event.target.value);
  };

  const handleAnsChange = (event, value) => {
    if (value === 'AgreeDisagree') setAnsArr(['Agree', 'Disagree'])
    else if (value === 'TrueFalse') setAnsArr(['True', 'False'])
    else if (value === 'YesNo') setAnsArr(['Yes', 'No'])
  }




  const [AnsOption, setAnsOption] = useState([])

  // const [answer, setAnswer] = useState({
  //   "option": "",
  //   "correct": false
  // });

  const [answer, setAnswer] = useState({
    "OptionText": "",
    "Precode": ""
  });

  const [answerIndex, setAnswerIndex] = useState(0)
  const [editAnswer, setEditAnswer] = useState(false)

  const handleAnswerChange = (event) => {
    setAnswer(event.target.value);
  };

  const handleOptionChange = (e) => {
    setAnswer({ ...answer, OptionText: e.target.value })
  }

  const handleCorrectChange = (e) => {
    setAnswer({ ...answer, Precode: e.target.value })
  }



  const handleAddOptions = () => {
    setAnsOption(prevOptions => {
      // Check if the option already exists
      const exists = prevOptions.some(opt => opt.OptionText === answer.OptionText);

      // If it doesn't exist, add it; otherwise, return the same array
      if (!exists) {
        return [...prevOptions, answer];
      }
      return prevOptions;
    });
    setAnswer({
      "OptionText": "",
      "Precode": ""
    })
  };

  const handEditAnswer = () => {
    let dataToUpdate = answer
    let tempArr = [...AnsOption]

    tempArr.splice(answerIndex, 1, dataToUpdate)
    setAnsOption(tempArr)

    setAnswer({
      "OptionText": "",
      "Precode": ""
    })
    setEditAnswer(false);

  }



  const handleDeleteBadge = () => {
    let tempArr = [...AnsOption]

    tempArr.splice(answerIndex, 1)
    setAnsOption(tempArr)
    setDeleteBadgeOpen(false)


    // let tempbadge = [...]
    // tempbadge.splice(badgeIndex, 1)
    // setBadges(tempbadge)
    // setDeleteBadgeOpen(false)
    // setBadgeIndex(0)
  }



  const [isQualifier, setIsQualifier] = useState(false);


  const handleIsQualifierChange = (event) => {
    setIsQualifier(event.target.value);
  };


  useEffect(() => {
    dispatch(getCategoryAction())
  }, [])
  useEffect(() => {
  }, [ansArr])

  return (
    <>
      <Modal sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
        <Box className='modal_box'>
          <Card sx={{ width: 600, p: 5 }}>
            <Typography variant='h5' sx={{ mb: 5 }} align='center'>Create Question Answer</Typography>
            <form onSubmit={handleSubmit(handleQns)}>
              <Stack spacing={3}>

                <FormControl>
                  <FormLabel>Question Type</FormLabel>
                  <RadioGroup>
                    <Stack direction='row'>
                      <FormControlLabel value={1} {...register('question_type')} control={<Radio />} label="Input" />
                      <FormControlLabel value={2} {...register('question_type')} control={<Radio />} label="Radio" />
                      <FormControlLabel value={3}  {...register('question_type')} control={<Radio />} label="DropDown" />
                    </Stack>
                  </RadioGroup>
                  <FormHelperText error={errors?.question_type?.message}>{errors?.question_type?.message}</FormHelperText>
                </FormControl>


              


                <TextField label="Question" variant="outlined" placeholder='Question' {...register('question')} error={errors?.question?.message} helperText={errors?.question?.message} />
                <TextField label="Question Id" variant="outlined" placeholder='Question ID' {...register('questionId')} error={errors?.questionId?.message} helperText={errors?.questionId?.message} />

                {
                  (question_type == 1) &&
                  <>
                    <InputLabel id="demo-simple-select-label">Select Data Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={dataType}
                      onChange={handleChange}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>Select Data Type</MenuItem>
                      <MenuItem value="string">String</MenuItem>
                      <MenuItem value="number">Numeric</MenuItem>
                    </Select>
                  </>
                }



                {(question_type == 2 || question_type == 3) && <Stack sx={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <FormLabel id="demo-controlled-radio-buttons-group" sx={{ mr: 2 }}>
                      Is Qualifier
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={isQualifier}
                      onChange={handleIsQualifierChange}
                    >
                      <FormControlLabel value="true" control={<Radio />} label="True" />
                      <FormControlLabel value="false" control={<Radio />} label="False" />
                    </RadioGroup>
                  </FormControl>
                </Stack>
                }


                {
                  (question_type == 2 || question_type == 3) && <Stack spacing={3} direction='row' sx={{ width: "100%" }}>

                    <Stack sx={{ width: "45%" }}>
                      <TextField
                        label="OptionText"
                        variant="outlined"
                        placeholder="Enter OptionText"
                        value={answer?.OptionText}
                        onChange={handleOptionChange}
                        fullWidth
                      />

                    </Stack >


                    <Stack sx={{ width: "45%" }}>
                      <TextField
                        label="Precode"
                        variant="outlined"
                        placeholder="Enter Precode"
                        value={answer?.Precode}
                        onChange={handleCorrectChange}
                        fullWidth
                      />

                    </Stack >


                    {answer?.OptionText && answer?.Precode && (editAnswer ? <Button
                      sx={{
                        backgroundColor: "black",
                        color: "white"
                      }}
                      onClick={() => handEditAnswer()}

                    >Edit</Button>
                      :
                      <Button
                        sx={{ backgroundColor: "black", color: "white" }}
                        onClick={() => handleAddOptions()}
                      >Add</Button>)}

                  </Stack>
                }



                {(question_type == 2 || question_type == 3) && (AnsOption?.length > 0) && <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 400 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>S.n. </TableCell>
                        <TableCell align="right">OptionText</TableCell>
                        <TableCell align="right">PreCode</TableCell>
                        <TableCell align="right">Edit</TableCell>
                        <TableCell align="right">Delete</TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {AnsOption.map((row, key) => (
                        <TableRow
                          key={row.option}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {key + 1}
                          </TableCell>
                          <TableCell align="right">{row.OptionText}</TableCell>
                          <TableCell align="right">{row.Precode}</TableCell>
                          <TableCell align="right">
                            <Button
                              variant="contained"
                              onClick={() => { setAnswer(row); setAnswerIndex(key); setEditAnswer(true) }}
                            >Edit</Button>
                          </TableCell>
                          <TableCell align="right">
                            <IconButton aria-label="delete">
                              <DeleteIcon onClick={() => { setAnswerIndex(key);setDeleteBadgeOpen(true) }} />
                            </IconButton>
                          </TableCell>

                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>}



                <Stack direction='row' spacing={2}>
                  <Button variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : 'Create Q & A'}</Button>
                  <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                </Stack>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>




      <Body>
        <Modal
          sx={{ overflow: 'scroll' }}
          open={deleteBadgeOpen}
          onClose={handleCloseOption}
        >
          <Box className="modal_box">
            <Card sx={{ width: 500, p: 5 }}>
              <Typography variant="h5" sx={{ mb: 5 }} align="center">
                Are You Sure You Want To Delete The Option
              </Typography>


              <Stack direction="row" sx={{ display: "flex", justifyContent: "space-around" }} spacing={5} mt={3} >
                <Button variant='contained' type='submit' onClick={() => handleDeleteBadge()}>Yes</Button>

                <Button variant="contained" color="error" onClick={handleCloseOption}>
                  NO
                </Button>
              </Stack>

            </Card>
          </Box>
        </Modal>

        {/* <SnackBarUI state={snack} setState={setSnack} status={status} message={message} /> */}

      </Body>

      <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
    </>
  )
}



CreateQuestionAnswer.propTypes = {
  state: PropTypes.any,
  setState: PropTypes.any
};
